import { message } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const BaseURL = process.env.REACT_APP_API_BASE_URL;
const http = axios.create({
  baseURL: BaseURL,
  headers: {
    "Content-type": "application/json",
  },
});
// 151.245.236.26:31523 MFR.7z
let navigate: (path: string) => void;

export const setNavigate = (nav: (path: string) => void) => {
    navigate = nav;
};
http.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `Bearer ${localStorage
        .getItem("jwt")
        ?.toString()}`;

    return config;
  },
  (error) => {
      return Promise.reject(error);
  }
);

http.interceptors.response.use(
  (response) => {

      return response;
  },
  (error) => {

      switch (error.response.status) {
          case 400: {
              message.error(`درخواست اشتباه است`);
              return Promise.reject(error);
          }
          case 500: {
              message.error(`خطای داخلی سرور`);
              return Promise.reject(error);
          }
          case 404: {
              message.error(`نتیجه ای با اطلاعات وارد شده پیدا نشد`);
              return Promise.reject(error);
          }
          case 403: {
              // navigate("/forbidden");
              return Promise.reject(error);
          }
          case 401: {
              message.error(
                  `دسترسی لازم برای این صفحه را ندارید. لطفا مجددا وارد شوید`
              );
              if (navigate) {
                  navigate("/login");
              }
              return Promise.reject(error);
          }
          case 409: {
              let validationErrors = Object.keys(error.response.data.data).map(
                  (key) => error.response.data.data[key]
              );
              validationErrors.map((item: any) => {
                  message.error(item);
              });
              return {
                  status: error.response.status,
                  message: error.response.data?.message,
                  validationErrors: validationErrors,
              };
          }
          case 503: {
              message.error(error.response.data.message);
              return Promise.reject(error);
          }

          default:
              break;
      }
  }
);

export default http;
